<template>
  <section
    v-if="acf.items"
    class="component-cfc6264d"
    resmed-component-name="citations"
    v-bind:style="{ background: acf.layout['background'] }"
  >
    <div class="component py-4 px-xs-sm-2">
      <div class="container">
        <div class="row">
          <div class="col col-lg-10 offset-lg-1">
            <div style="position: relative" v-if="acf.items.length > 1">
              <a
                href="#"
                v-on:click.prevent="all = !all"
                class="btn navigation-icon toggle-all"
                v-bind:class="{ 'less-collapse': all, 'move-expand': !all }"
              >
                <!--  -->
              </a>
            </div>
            <h5 class="heading-xs">{{ acf.reference }}</h5>
            <div class="items">
              <div
                class="item"
                v-for="(item, index) in acf.items"
                v-bind:data-citation="item.number"
              >
                <div class="wrapper" v-show="all || index === 0">
                  <div class="number">{{ item.number }}</div>
                  <div class="content" v-html="item.source">
                    <!--  -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { scroll } from "../../mixins/index";

export default {
  name: "component-cfc6264d", // citations
  props: ["acf"],
  data() {
    return {
      all: false,
    };
  },
  mixins: [scroll],
  methods: {
    tooltip() {
      let sup = $(".page").find("sup"),
        citation = undefined;

      sup
        .on("click", (event) => {
          if (event.target.nodeName === "A") {
            return;
          }

          bus.$emit("citation:active", true);
          if (
            ["lg", "xl"].includes(this.$root.mode) &&
            !["iPad Pro"].includes(this.$root.tablet)
          ) {
            this.$nextTick(() => {
              this.scroll({
                to: `[data-citation='${citation}']`,
                duration: 3000,
                offset: 32 * 2 + 16, // compensate for paddings
              });
            });
          }
        })
        .mouseenter((event) => {
          let el = $(event.target);
          let offset = el.offset(); // { left, right }
          let viewport = $(window).width();

          if (el[0].nodeName === "SUP") {
            citation = el.text();
            let close =
              '<a href="#" class="btn navigation-icon close d-md-none"></a>';
            let content = $(`.page [data-citation="${citation}"]`).find(
              ".content"
            )[0].outerHTML;

            if (!el.find(".tooltip").length) {
              el.append(`<div class="tooltip">${close}${content}</div>`);

              let tooltip = el.find(".tooltip"),
                height = tooltip.outerHeight() - 16; // compensate for padding overlay

              // xs and sm only - left and right
              if (this.$root.mode === "xs" || this.$root.mode === "sm") {
                let half = tooltip.outerWidth() / 2,
                  tooltip_offset = tooltip.offset();

                if (offset.left > viewport / 2) {
                  // console.log('sup is on the right');
                  tooltip.css({
                    left:
                      -half + -(tooltip_offset.left - viewport / 2) + 16 / 2,
                  });
                } else {
                  // console.log('sup is on the left');
                  tooltip.css({
                    right:
                      -half + -(viewport / 2 - tooltip_offset.left) + 16 / 2,
                    left: "auto",
                  });
                }
              }
              // end
              tooltip.css({ top: -height });

              //  check if any part of the tooltip is out of the viewport
              {
                let bounding = tooltip[0].getBoundingClientRect();

                // top is out of viewport
                if (bounding.top < 0) {
                  // ->
                }

                // left side is out of viewoprt
                if (bounding.left < 0) {
                  let a = this.$root.mode === "xl" ? "12rem" : "6rem";
                  tooltip.find("> div").css({ transform: `translateX(${a})` });
                }

                // bottom is out of viewport
                if (
                  bounding.bottom >
                  (window.innerHeight || document.documentElement.clientHeight)
                ) {
                  // ->
                }

                // right side is out of viewport
                if (
                  bounding.right >
                  (window.innerWidth || document.documentElement.clientWidth)
                ) {
                  let a = this.$root.mode === "xl" ? "-12rem" : "-6rem";
                  tooltip.find("> div").css({ transform: `translateX(${a})` });
                }
              }

              // close btn (xs and sm)
              $("sup")
                .find(".close")
                .on("click", (event) => {
                  event.preventDefault();
                  $(event.delegateTarget).closest(".tooltip").remove();
                });
            }
          }
        })
        .mouseleave((event) => {
          $(event.delegateTarget).find(".tooltip").remove();
        });
    },
  },
  mounted() {
    bus.$on("citation:active", (arg) => {
      this.all = true;
    });

    bus.$on("tooltip:bind-event", () => {
      this.tooltip();
    });

    this.tooltip();
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-cfc6264d {
  background-color: #edf3f9;
}

.component {
  .col {
    position: static; // scroll --> offsetTop
  }

  * {
    // exception
    font-size: 0.75rem;
    line-height: 1.5;
  }

  h5 {
    margin-bottom: 1.125rem;
    padding-bottom: 0.875rem;

    border-bottom: 1px solid $cc-resmed-grey-50;
  }

  .btn {
    background-size: auto auto;
  }

  .item {
    position: relative;

    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-wrap: break-word;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    .number {
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 700;
      line-height: 1.9;

      text-align: center;
      position: absolute;
      top: -0.25rem;
      left: 0;
      border: 1px solid $cc-resmed-grey-50;
      border-radius: 50%;
      width: 24px;
      height: 24px;
    }

    .content {
      padding-left: 2.5rem;
    }
  }

  .toggle-all {
    position: absolute;
    top: -0.5rem;
    right: 0;

    transform: scale(0.625);

    &.less-collapse {
      background-color: $cc-resmed-grey-30;
    }
  }
}
</style>


<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/base/utilities";

/* sup / tooltip
    --------------------------------------------- */
span {
  &.citation-group {
    .citation {
      margin-right: 0.5rem;
    }
  }

  &.citation {
    position: relative;
    z-index: 99;
    padding-left: 1rem;
    white-space: normal;

    sup {
      @extend %fine-print;
      font-size: 11px;
      border-radius: 50%;
      background-color: $cc-resmed-action-red;
      color: $cc-resmed-white;

      display: block;
      width: 1.125rem;
      height: 1.125rem;
      text-align: center;
      // font-family: Arial; // do not change
      // line-height: 1.6;
      line-height: 16px;
      font-weight: 600;
      cursor: pointer;

      position: absolute;
      left: 4px;
      transform: translateY(0);

      display: flex;
      align-items: center;
      justify-content: center;

      .tooltip {
        animation: fade-in 0.5s ease;

        position: fixed;
        z-index: 90;
        width: 80vw;
        // min-height: 100px;

        left: 50%;
        transform: translateX(-50%);
        padding-bottom: 40px;

        display: flex;
        flex-direction: column;

        @media (max-width: 767px) {
          transform: translateX(0) !important;
        }

        @media (min-width: 768px) {
          position: absolute;

          width: auto;
          width: 280px;
          min-height: 100px;

          &:after {
            $size: 0.75rem;
            @include caret($size);
            border-top: $size solid $cc-resmed-white;

            left: 50%;
            transform: translateX(-50%);
            bottom: 1rem;
          }
        }

        @media (min-width: 1200px) {
          width: 480px;
        }

        > .content {
          text-align: left;
          cursor: default;
          font-weight: 400;

          * {
            // exception
            font-size: 0.75rem;
            line-height: 1.5;
            white-space: normal !important;
          }

          p {
            color: $cc-resmed-black !important;
          }

          a {
            /* these are technically the same, but use both */
            overflow-wrap: break-word;
            word-wrap: break-word;
            -ms-word-wrap: break-word;
          }

          background-color: $cc-resmed-white;
          box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);

          flex-grow: 1;
          padding: 1.5rem 2.5rem;
          border-radius: 6px;

          color: $cc-resmed-black;
        }
      }
    }
  }
}

h1 {
  .citation > sup {
    top: 12px;
  }
}

h2,
h3,
h4 {
  .citation > sup {
    top: 8px;
  }
}

h5 {
  .citation > sup {
    top: 0;
  }
}

p,
li {
  .citation {
    display: inline-block;
    width: 1.125rem;
    height: 1.125rem;
    white-space: nowrap;

    sup {
      top: 0;
      left: 0;
    }
  }
}

.tooltip .close {
  position: absolute;
  top: -1.125rem;
  right: -1.125rem;
  transform: scale(0.85);
}
</style>